import { ButtonPage } from "./page-button";
import { PageRoot } from "./page-root";
import { PageHeader } from "./page-header";
import { PageSearch } from "./page-search";
import { ClientHeader } from "./system-header";
import { PageError } from "./page-error";
export const Page = {
  Root: PageRoot,
  CHeader: ClientHeader,
  Button: ButtonPage,
  Header: PageHeader,
  Search: PageSearch,
  Error: PageError
};
